import { getEntityRef } from "@client/content/lib/helper";
import { setActiveCourse } from "@client/content/modules/CourseDetail/actions";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom, type IFrameExitArgs } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { reload } from "../../actions";
import { makeFilteredCoursesSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeCourseImageStyleSelector, makeCourseStyleSelector } from "./selectors";

type Props = RootContainerProps & {
  isEnrolled: boolean;
};

const makeMapStateToProps = () => {
  const availableCoursesSelector = makeFilteredCoursesSelector();
  const apiInfoSelector = makeModuleApiInfoSelector();
  const courseStyleSelector = makeCourseStyleSelector();
  const courseImageStyleSelector = makeCourseImageStyleSelector();

  return (state: AppState, props: Props): MapProps => {
    const apiInfo = apiInfoSelector(state, props);
    const courses = availableCoursesSelector(state, props);

    return {
      ...props,
      apiInfo,
      courseImageStyle: courseImageStyleSelector(state, props),
      courses,
      courseStyle: courseStyleSelector(state, props),

      isEnrolled: props.isEnrolled,
      isVisible: !!courses.length
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onCourseClick: (courseId: string) => dispatch(setActiveCourse(getEntityRef(props), courseId)),
  onMembershipCourseExit: (exitArgs: IFrameExitArgs | undefined) => dispatch(reload(getEntityRef(props), exitArgs))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
